import { createSlice } from '@reduxjs/toolkit';

export const LOGOHASH_FEATURE_KEY = 'logoHash';

export interface BrandingState {
  logoHashDate: string;
}

const initialState: BrandingState = {
  logoHashDate: '',
};

export const logoHashSlice = createSlice({
  name: LOGOHASH_FEATURE_KEY,
  initialState,
  reducers: {
    setLogoHashDate: (state) => {
      const hashDate = Date.now().toPrecision();
      state.logoHashDate = hashDate;
    },
  },
});

export const { setLogoHashDate } = logoHashSlice.actions;

export const logoHashReducer = logoHashSlice.reducer;
